<app-label-inflator #labelCalculator hidden [labelComponentInterface]="data"></app-label-inflator>
<div class="main-content">
  <div class="background-content" [style.background-color]="viewModel.stiiizyCardBackgroundColor$ | async">
    <app-print-card-background-image-with-color-overlay-and-opacity [cardBackground]="data">
    </app-print-card-background-image-with-color-overlay-and-opacity>
  </div>
  <div class="top-content">
    <img
      *ngIf="data | getVariantAssetForCard | async as variantAsset"
      appImage
      class="brand-logo"
      [asset]="variantAsset"
      src=""
      alt="" />
  </div>

  <div class="bottom-content">
    <div class="product-info" [style.color]="viewModel.headerTextColor$ | async">
      <div class="title-quantity-and-unit-size">
        <div class="product-card-title">
          {{ data | sectionRowViewModelBasicMethod: 'getRowTitle' | trimSafely | uppercase }}
        </div>
        <div class="product-card-size-and-label">
          <div
            *ngIf="
              viewModel
                | getExpandedGridSizeMode: (viewModel.spoofedGridColViewModels$ | async) : true : false
                | async as size
            ">
            {{ size }}
          </div>

          <app-label-inflator
            class="print-card-label"
            [columnLabel]="false"
            [labelComponentInterface]="data"
            [reset]="false">
          </app-label-inflator>
        </div>
      </div>

      <div class="pricing-container">
        <div
          *ngIf="(data?.menu | printCardMenuBasicMethod: 'getNumberOfBadgesForVariant' : data) > 0"
          class="badge-container">
          <img
            *ngFor="let variantBadge of data | printCardBadges"
            appImage
            class="badge"
            [asset]="variantBadge?.image"
            alt="badge"
            src="" />
        </div>
        <app-column-primary-price
          [menu]="viewModel.cardStackMenu$ | async"
          [section]="viewModel.cardStack$ | async"
          [colVm]="viewModel.spoofedColViewModel$ | async"
          [rowVm]="viewModel.cardData$ | async"
          [locConfig]="viewModel.locationConfig$ | async"
          [locationId]="viewModel.locationId$ | async"
          [productStylingVm]="viewModel">
        </app-column-primary-price>
      </div>
    </div>
    <div class="strain-info" [style.color]="viewModel.bodyTextColor$ | async">
      <div class="product-card-available-strains" [style.color]="viewModel.bodyTextColor$ | async">
        AVAILABLE STRAINS
      </div>
      <div
        *ngFor="let variant of viewModel.visibleVariantStrains$ | async"
        class="product-card-individual-product-info">
        <div
          class="product-card-variant-name"
          appPrintCardScaleDownText
          [maxHeightInPx]="14"
          [maxWidthInPx]="248"
          [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
          [style.color]="viewModel.bodyTextColor$ | async">
          {{ data | sectionRowViewModelBasicMethod: 'getRowTitleFor' : variant | trimSafely | uppercase }}
        </div>
        <div
          *ngIf="
            !(viewModel.isAccessory$ | async) &&
            !(viewModel.isNonCannabinoidOtherVariant$ | async) &&
            (data | sectionRowViewModelBasicMethod: 'getReadableStrainTypeFor' : variant | trimSafely) as strainType
          "
          class="product-card-strain"
          [style.color]="viewModel.bodyTextColor$ | async">
          {{ strainType | uppercase }}
        </div>
      </div>
      <div *ngIf="viewModel.nMoreStrains$ | async as nFlavours" class="plus-n-more-strains">+{{ nFlavours }} MORE</div>
    </div>
  </div>
</div>
